export default __webpack_public_path__ + "static/media/sec-3a.bb543de4.png";